// extracted by mini-css-extract-plugin
export var linkText = "_mi-0";